const CitacaoSchema = () => ({
  title: 'AgSUS Citação',
  fieldsets: [
    {
      id: 'default',
      title: 'Citação',
      fields: ['texto', 'nome', 'cargo', 'composicao', 'cor'],
    },
    {
      id: 'mais',
      title: 'Foto e fonte',
      fields: ['foto', 'link', 'textoLink'],
    },
  ],
  properties: {
    texto: {
      title: 'Fala',
      widget: 'textarea',
      description:
        'Sem aspas: elas entram no desenho. Linha em branco separa parágrafos.',
    },
    nome: { title: 'Nome de quem fala' },
    cargo: {
      title: 'Cargo, instituição ou descrição',
      description: 'Ex.: Diretor-presidente da AgSUS',
    },
    composicao: {
      title: 'Composição',
      choices: [
        ['cartao', 'Cartão branco com barra de cor'],
        ['painel', 'Painel azul (depoimento em destaque)'],
      ],
      default: 'cartao',
      noValueOption: false,
    },
    cor: {
      title: 'Cor do cartão',
      choices: [
        ['verde', 'Verde'],
        ['azul', 'Azul'],
        ['vermelho', 'Vermelho'],
      ],
      default: 'verde',
      noValueOption: false,
    },
    foto: {
      title: 'Foto (opcional)',
      widget: 'object_browser',
      mode: 'image',
      allowExternals: false,
      description: 'Aparece redonda, ao lado do nome.',
    },
    link: {
      title: 'Link da fonte (opcional)',
      description: 'A notícia ou o documento de onde veio a fala.',
    },
    textoLink: { title: 'Texto do link', default: 'Fonte' },
  },
  required: [],
});

export default CitacaoSchema;
